import { PinnedComplianceNotificationCard } from './pinned-compliance-notification-card';
import {
  type ComplianceNotificationAnalyticsPorts,
  type PinnedComplianceNotification,
} from './types';

/**
 * The pinned block above the notification list. Unread only — a read
 * recommendation is rendered by `NotificationsList` in time order instead. The
 * rows arrive filtered: the panel already holds them for its own guards.
 */
export const PinnedComplianceNotificationsSection = ({
  notifications,
  onOpenSettings,
  onViewed,
  onClicked,
  onDismissed,
}: {
  notifications: PinnedComplianceNotification[];
  onOpenSettings: (settingsRoute: string) => void;
} & ComplianceNotificationAnalyticsPorts) => {
  if (notifications.length === 0) return null;

  return (
    <div
      className="flex flex-col pb-1"
      data-testid="pinned-compliance-notifications-section"
    >
      {notifications.map((notification) => (
        <PinnedComplianceNotificationCard
          key={notification.type}
          notification={notification}
          onOpenSettings={onOpenSettings}
          onViewed={onViewed}
          onClicked={onClicked}
          onDismissed={onDismissed}
        />
      ))}
    </div>
  );
};
